import { ReactNode } from "react";
import { SudoProvider } from "../../SudoContext";
import SudoDialog from "../../SudoDialog/SudoDialog";

/**
 * Scopes the MFA/sudo verification flow to a single write pane. The nested
 * `SudoProvider` routes the OTP screens under `basename` so the pane stays
 * mounted while `SudoDialog` renders the verification as a modal overlay.
 */
const SudoWritePane = ({
  basename,
  children,
}: {
  basename: string;
  children: ReactNode;
}) => (
  <SudoProvider basename={basename}>
    {children}
    <SudoDialog />
  </SudoProvider>
);

export default SudoWritePane;

